import { render, staticRenderFns } from "./orgDetail.vue?vue&type=template&id=a1321246&scoped=true"
import script from "./orgDetail.vue?vue&type=script&lang=ts"
export * from "./orgDetail.vue?vue&type=script&lang=ts"
import style0 from "./orgDetail.vue?vue&type=style&index=0&id=a1321246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1321246",
  null
  
)

export default component.exports